import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@mui/material';
import { withStyles } from '@mui/styles';

const styles = {
  root: {
    height: 24,
    width: 48,
    padding: '0',
    overflow: 'hidden',
    marginLeft: 0,
  },
  switchBase: {
    padding: 4,

    '&$checked': {
      transform: 'translateX(24px)',
    },
  },
  track: {
    backgroundColor: '#d8d1d1',
    opacity: 1,
    height: 24,
    width: 48,
    borderRadius: 12,
  },
  checked: {
    '& + .MuiSwitch-track': {
      backgroundColor: '#ebeeef !important',
      opacity: '1 !important',
    },
  },
  thumb: {
    borderRadius: 8,
    height: 16,
    width: 16,
  },
};

const CustomizedSwitch = withStyles(styles)(Switch);

function Toggle({ toggled, onToggle, disabled }) {
  return <CustomizedSwitch disabled={disabled} color="primary" checked={toggled} onChange={onToggle} />;
}

Toggle.propTypes = {
  toggled: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default Toggle;
